import { render, staticRenderFns } from "./SkinIntelTooltip.vue?vue&type=template&id=3f0b5004&"
import script from "./SkinIntelTooltip.vue?vue&type=script&lang=ts&"
export * from "./SkinIntelTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports